import { createSelector } from '@ngrx/store';
import { getDragonflyCustomersState } from '../reducers/index';

export const getSharedState = createSelector(getDragonflyCustomersState, (state) => state?.shared);

export const getViewMemberSummary = createSelector(
  getSharedState,
  (state) => state?.viewMemberSummary,
);

export const getViewMemberSearch = createSelector(
  getSharedState,
  (state) => state?.viewMemberSearch,
);

export const getViewCustomerSummary = createSelector(
  getSharedState,
  (state) => state?.viewCustomerSummary,
);

export const getCustomerActiveTab = createSelector(
  getSharedState,
  (state) => state?.customerActiveTab,
);

export const getSelectedSearchTabIndex = createSelector(
  getSharedState,
  (state) => state?.selectedSearchTabIndex,
);
